export const GETTING_CONTENT_DATA = "GETTING_CONTENT_DATA"
export const GETTING_CONTENT_DATA_SUCCESS = "GETTING_CONTENT_DATA_SUCCESS"
export const GETTING_CONTENT_DATA_FAILED = "GETTING_CONTENT_DATA_FAILED"